import { getDefaultPO, getCurrentEmployee, getDefaultRFQID } from '@/utils/shared'

export const ModelNew = () => {
  return {
    rfqid: '',
    rfqTypeID: null,
    customerCompanyID: null,
    customerContactID: null,
    customerCompanyDetailID: null,
    po: null,
    poDate: new Date()
  }
}
export const Model = () => {
  const employee = getCurrentEmployee()
  return {
    id: '',
    rfqid: getDefaultRFQID(),
    customerCompanyID: null,
    rfqTypeID: 2,
    baxEmployeeID: employee && employee.id,
    priorityID: 1,
    customerContactID: null,
    customerCompanyDetailID: null,
    observation: '',
    po: null,
    poDate: null,
    requestedDate: null,
    orderRatingScoreID: null,
    paymentTermID: null,
    shipToCompanyID: null,
    shipToCompanyDetailID: null,
    shipToContactID: null,
    customerForwarderID: null
  }
}

export const ModelPO = () => {
  return {
    id: null,
    po: getDefaultPO(),
    poDate: new Date(),
    requestedDate: null,
    orderRatingScoreID: null,
    paymentTermID: null,
    shipToCompanyID: null,
    shipToCompanyDetailID: null,
    shipToContactID: null,
    customerForwarderID: null
  }
}

export const ModelInfoPOShort = () => {
  return {
    poDate: null,
    requestedDate: null,
    orderRatingScoreID: null,
    paymentTermID: null,
    shipToCompanyID: null,
    shipToCompanyDetailID: null,
    shipToContactID: null,
    customerForwarderID: null
  }
}

export const ModelSharedForm = () => {
  return {
    rfqid: getDefaultRFQID(),
    baxPO: null,
    po: null,
    customerCompanyID: null,
    customerContactID: null,
    customerCompanyDetailID: null,
    rfqTypeID: null,
    shipToCompanyID: null,
    shipToCompanyContactID: null,
    shipToCompanyDetailID: null,
    shipViaForwarderID: null,
    vatID: null,
    priorityID: null
  }
}
export const ModelFrance = () => {
  return {
    customerCompanyID: 540,
    customerContactID: 30427,
    customerCompanyDetailID: 540,
    shipToCompanyID: 540,
    shipToCompanyDetailID: 540,
    shipToCompanyContactID: 30427,
    // shipViaForwarderID: 4622,
    vatID: 2,
    priorityID: 4
  }
}

export const ModelUSA = () => {
  return {
    customerCompanyID: 5200,
    customerContactID: 16642,
    customerCompanyDetailID: 7125,
    shipToCompanyID: 5200,
    shipToCompanyDetailID: 7125,
    shipToCompanyContactID: 16642,
    // shipViaForwarderID: 880,
    vatID: 4,
    priorityID: 2
  }
}
